import React, { useEffect, useState } from 'react';
import API from '../Api';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Navigation, Pagination, Autoplay } from 'swiper/modules';


import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import SubPageHeader from '../../components/common/SubPageHeader';
// import SubPageFooter from '../../components/common/SubPageFooter';
import founderFallback from '../../assets/images/IMG_2467.jpg';

const Founder = () => {

  const [data, setData] = useState({});

  useEffect(() => {
    const fetchFounderData = async () => {
      try {
        const res = await API.get('get-content/Founder/');
        setData(res.data);
      } catch (err) {
        console.error("Error loading founder data:", err);
      }
    };
    fetchFounderData();
  }, []);

  const resolveImageUrl = (path, fallback) => {
    if (!path) return fallback;
    if (path.startsWith('http')) return path;
    const cleanPath = path.startsWith('/') ? path : `/media/${path}`;
    return `${process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005'}${cleanPath}`;
  };
  const slides = [
    {
      title: "Founder",
      content: (
        <div className="space-y-6">
          <p><span className="font-bold">VINAY RAMBHAU SATPUTE</span> is the Amazon Best Seller Author for his book <span className="font-bold">"WE CAN IF U WILL"</span> Co-authored by his daughter OWEE and also awarded as the first book written by DAD-DAUGHTER DUO in INDIA -by the India book of records.</p>
          <p>He also holds another record of being the youngest DAD-DAUGHTER duo in INDIA to certify as PADI (Professional Association of Diving Instructors) licensed SCUBA divers by India Book of Records.</p>
          <p className="font-medium italic">A versatile personality believing in exploring life to the fullest potential, his main motive is to SPREAD HAPPINESS.</p>
        </div>
      )
    },

    
    {
      title: "Journey With Vinay Satpute",
      content: (
        <div className="space-y-6">
          <p>A versatile personality believing in exploring life to the fullest potential, his main motive is to SPREAD HAPPINESS.</p>
          <p>A Chartered Civil Engineer by profession, he is a Successful Entrepreneur in Industrial Designing and Construction. He is an ex-student of the school "JNANA PRABODHINI NAVNAGAR VIDYALAYA" - devoted to create exemplary leaders to serve the community in different fields.</p>
        </div>
      )
    },
    {
      title: "Journey With Vinay Satpute",
      content: (
        <div className="space-y-4">
          <p className="font-medium italic text-orange-200">The principles of <br /> "MATRU DEVO BHAVA" - My Mother is my God <br /> "PITRU DEVO BHAVA" - My Father is my God <br /> "RASHTRA DEVO BHAVA" - My Nation is my God</p>
          <p>Advocated by the school were inculcated in him at an early age and have played a major role in imbibing moral values and his overall development.</p>
          <p>He graduated as a Civil engineer from a college affiliated to University of Pune - K. K. Wagh College of Engineering, Nasik in 1998.</p>
        </div>
      )
    },
    {
        title: "Journey With Vinay Satpute",
        content: (
          <div className="space-y-6">
            <p>He is a motivational speaker - a Certified International Life success Coach and a part of Knowledge brokers movement of world famous coaches Tony Robbins and Dean Graziosi.</p>
            <p>After 20 years of successful construction business he followed his passion to live life with a design and not by default and founded <br /> <span className="font-bold text-2xl block mt-2 underline">"THE GLOBAL SCHOOL OF HAPPINESS"</span></p>
          </div>
        )
      },
      {
        title: "Journey With Vinay Satpute",
        content: (
          <div className="space-y-6">
            <p>His "DESIGN24" course is creating success stories all over the globe. People from different profession, countries, age groups have undergone eternal transformation. All students undergoing important crucial examinations have immensely benefited from this course.</p>
            <p>Many have transitioned from their current jobs or businesses to live a life of their choice, their passion and are feeling HAPPINESS in the true sense of the word.</p>
          </div>
        )
      },
      {
        title: "Journey With Vinay Satpute",
        content: (
          <div className="space-y-6">
            <p>He practices and preaches the study of ancient science of hand gesture "MUDRAS" and has cured many patients suffering from different ailments. Mudras also helped many covid patients to regain normalcy post covid.</p>
          </div>
        )
      },
      {
        title: "Journey With Vinay Satpute",
        content: (
          <div className="space-y-6">
            <p>Living with Nature being one of the core values of "the global school of happiness" he does his farming activities regularly at the Dawadipune centre.</p>
            <p className="uppercase font-bold tracking-wider border-t border-white/20 pt-4">A author, licenced scuba diver, engineer, philosopher, yoga teacher, Mudra sadhak, a farmer - VINAY loves every soul and wishes to SPREAD HAPPINESS to each & every soul on this planet.</p>
          </div>
        )
      }
  ];

  return (
    <div className="bg-white min-h-screen">
      <SubPageHeader title="Founder" subtitle="The Global School of Happiness" />

      <section className="relative min-h-[650px] lg:min-h-[800px] flex items-stretch overflow-hidden mt-12 mb-12 lg:mt-32 lg:mb-32">
        {/* Background Split */}
        <div className="absolute inset-0 hidden lg:flex">
          <div className="w-1/3 bg-white h-full"></div>
          <div className="w-2/3 bg-[#1a365d] h-full"></div>
        </div>
        {/* Mobile Background */}
        <div className="absolute inset-0 bg-[#1a365d] lg:hidden"></div>

        <div className="container mx-auto px-4 md:px-6 relative z-10 flex flex-col lg:flex-row items-center">
          
          
          <div className="lg:w-1/3 flex justify-center lg:justify-end z-20 mb-12 lg:mb-0 relative">
            <div className="bg-white p-2 border-4 border-[#007dbd] shadow-2xl max-w-[260px] sm:max-w-[320px] md:max-w-sm mx-auto lg:translate-x-32" data-aos="fade-right">
              <img 
                src={resolveImageUrl(data.founder_image, founderFallback) + `?t=${new Date().getTime()}`} 
                alt="Vinay Satpute" 
                className="w-full h-auto object-cover" 
              />
              <div className="py-6 text-center">
                <h3 className="text-2xl sm:text-3xl md:text-4xl text-[#333] font-serif">
                  <span className="text-[#c18d45] text-4xl sm:text-5xl font-bold">V</span>inay Satpute
                </h3>
                <p className="text-[10px] sm:text-xs uppercase tracking-[1px] sm:tracking-[2px] text-gray-500 mt-2 italic font-sans">
                  The MIND TRIGGERER who SPREADS <br /> HAPPINESS ALL OVER
                </p>
              </div>
            </div>
          </div>

          
          <div className="w-full lg:w-2/3 lg:pl-20 mt-8 lg:mt-0">
            <Swiper
                
                modules={[Navigation, Pagination, Autoplay]} 
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                
                navigation={{ 
                    nextEl: '.slick-next', 
                    prevEl: '.slick-prev' 
                }}
                pagination={{ clickable: true }}
                
                className="pb-20 pt-6 md:pt-10"
            >
              {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div className="text-white text-center lg:text-left  min-h-[220px] sm:min-h-[260px] md:min-h-[350px]">
                    <h2 className="text-2xl sm:text-3xl md:text-5xl mb-4 italic text-white" style={{ fontFamily: "'Viner Hand ITC', cursive" }}>
                      {slide.title}
                    </h2>
                    <div className="w-16 md:w-20 h-0.5 bg-orange-400 mx-auto lg:mx-0 mb-6 md:mb-10"></div>
                    <div className=" text-sm sm:text-base md:text-xl leading-relaxed font-sans tracking-normal md:tracking-wide text-white">
                      {slide.content}
                    </div>
                  </div>
                </SwiperSlide>
              ))}

              {/* Custom Navigation Arrows */}
              <div className="flex justify-center lg:justify-start gap-6 mt-12 absolute bottom-0 left-0 right-0 lg:static z-30">
                <button className="span-arrow slick-prev select-none">
                    &lt;
                </button>
                <button className="span-arrow slick-next select-none">
                    &gt;
                </button>
              </div>
            </Swiper>
          </div>
        </div>
      </section>

      {/* <SubPageFooter /> */}

      <style>{`
        .span-arrow {
            position: relative; 
            z-index: 50;       
            cursor: pointer !important;
            pointer-events: auto !important;
            display: inline-flex;
            width: 50px;
            height: 50px;
            cursor: pointer;
            color: white;
            border: 1px solid rgba(255, 255, 255, 0.4);
            border-radius: 50%;
            transition: all 0.3s ease;
            align-items: center;
            justify-content: center;
            font-size: 22px;
            background: transparent;
        }
        .span-arrow:hover {
            background-color: white;
            color: #59b1e0;
            border-color: white;
            transform: scale(1.1);
        }
        .swiper-pagination-bullet {
            background: white !important;
            width: 10px;
            height: 10px;
            opacity: 0.3;
        }
        .swiper-pagination-bullet-active {
            background: white !important;
            opacity: 1;
        }
        @media (max-width: 768px) {
          .span-arrow {
              width: 40px;
              height: 40px;
              font-size: 18px;
          }
        }
      `}</style>
    </div>
  );
};

export default Founder;